import React from 'react'
import './Partnersec.css'
import pimg from '../../assets/others/11102033.png'

const Partnersec = () => {
  return (
    <div class="partner-section ws-section">
        <div class="container text-center">
                    <div class="row">
                        <div class="col-lg-5">
                            <h2 class="ws-section_heading pd-03 mb-1 text-left">Our Industry Connections</h2>
                        </div>
                        <div class="col-lg-7 img-sec">
                            <img src={pimg} alt=''/>
                        </div>
                    </div>
                   
         </div>
     </div>
  )
}

export default Partnersec